const LINKS: [string, string][] = [
  ['calculator', 'Calculator'],
  ['pipeline', 'My cars'],
  ['dashboard', 'Dashboard'],
  ['capital', 'Grow cash'],
  ['rules', 'Rules'],
  ['settings', 'Settings'],
];

export function Nav({ current }: { current: string }) {
  return (
    <header className="topbar">
      <a className="brand" href="#/calculator">Car Flip Planner</a>
      <nav aria-label="Main">
        {LINKS.map(([path, label]) => (
          <a key={path} href={`#/${path}`} aria-current={current === path ? 'page' : undefined}>{label}</a>
        ))}
      </nav>
    </header>
  );
}
